import { ReactElement } from 'react';
import { DataPointWithValue } from '@src/types/DataPoint';

interface UnitProps {
  label: string;
  dataPoints: DataPointWithValue[];
  rectangleXCoordinate: string;
  rectangleYCoordinate: string;
  textStartingXCoordinate: number;
  textStartingYCoordinate: number;
  lineTransformXCoordinate?: number;
  lineTransformYCoordinate?: number;
  skipHorizontalLine?: boolean;
}

type TextCoordinates = {
  yCoordinate: number;
};

function Unit(props: UnitProps): ReactElement {
  const {
    label,
    dataPoints,
    rectangleXCoordinate,
    rectangleYCoordinate,
    textStartingXCoordinate,
    textStartingYCoordinate,
  } = props;

  const getTextCoordinates = (rowIndex: number): TextCoordinates => {
    const verticalSpace = 10;
    const verticalOffset = verticalSpace * rowIndex;

    return {
      yCoordinate: textStartingYCoordinate + verticalOffset,
    };
  };

  const textProps = {
    fill: 'black',
    stroke: 'none',
    fontSize: '5px',
  };

  const getDataPointValue = (pointName: string) => {
    const filteredItem = dataPoints.filter(
      (point) => point.pointName === pointName,
    );

    return filteredItem.length > 0 ? filteredItem[0].value : '';
  };

  return (
    <>
      <rect
        x={rectangleXCoordinate}
        y={rectangleYCoordinate}
        width='65'
        height='75'
        fill='white'
      />

      <text
        fontWeight='bold'
        x={textStartingXCoordinate}
        y={getTextCoordinates(1).yCoordinate}
        {...textProps}
      >
        {label}
      </text>

      <text
        x={textStartingXCoordinate}
        y={getTextCoordinates(2).yCoordinate}
        {...textProps}
      >
        Racks Online: {getDataPointValue('racksonline')}
      </text>

      <text
        x={textStartingXCoordinate}
        y={getTextCoordinates(3).yCoordinate}
        {...textProps}
      >
        kW: {getDataPointValue('kw')}
      </text>

      <text
        x={textStartingXCoordinate}
        y={getTextCoordinates(4).yCoordinate}
        {...textProps}
      >
        kVAR: {getDataPointValue('kvar')}
      </text>

      <text
        x={textStartingXCoordinate}
        y={getTextCoordinates(5).yCoordinate}
        {...textProps}
      >
        SOC: {getDataPointValue('soc')}
      </text>

      <text
        x={textStartingXCoordinate}
        y={getTextCoordinates(6).yCoordinate}
        {...textProps}
      >
        Inv Status: {getDataPointValue('inv_status')}
      </text>

      <text
        x={textStartingXCoordinate}
        y={getTextCoordinates(7).yCoordinate}
        {...textProps}
      >
        Run Mode: {getDataPointValue('run_mode')}
      </text>
    </>
  );
}

export default Unit;
